import { trigger, state, style, transition, animate } from '@angular/animations';

export class ModalAnimationState {
    static get active() { return 'active'; }
    static get inactive() { return 'inactive'; }
}

export const modalAnimations: any[] = [
    trigger('fadeBox', [
        state(ModalAnimationState.inactive, style({
            transform: 'translate(-50%,-50%) scale(0.8)',
            visibility: 'collapse'
        })),
        state(ModalAnimationState.active, style({
            visibility: 'visible',
            transform: 'translate(-50%,-50%) scale(1)'
        })),
        transition(`${ModalAnimationState.inactive} => ${ModalAnimationState.active}`, animate('200ms linear')),
        transition(`${ModalAnimationState.active} => ${ModalAnimationState.inactive}`, animate('100ms linear')),
    ]),

    trigger('fadeBackdrop', [
        state(ModalAnimationState.inactive, style({
            opacity: '0'
        })),
        state(ModalAnimationState.active, style({
            opacity: '0.7'
        })),
        transition(`${ModalAnimationState.inactive} => ${ModalAnimationState.active}`, animate('200ms linear')),
        transition(`${ModalAnimationState.active} => ${ModalAnimationState.inactive}`, animate('100ms linear')),
    ]),

    trigger('isOpen', [
        state(ModalAnimationState.inactive, style({
            visibility: 'collapse'
        })),
        state(ModalAnimationState.active, style({
            visibility: 'visible'
        })),
        transition(`${ModalAnimationState.inactive} => ${ModalAnimationState.active}`, animate('200ms linear')),
        transition(`${ModalAnimationState.active} => ${ModalAnimationState.inactive}`, animate('100ms linear')),
    ])
];